import { arrayToDistinct } from "@opendash/core";
import { useTranslation } from "@opendash/i18n";
import { AutoComplete, Form } from "antd";
import React, { useMemo } from "react";
import FormItemProps from "../../../types/FormItemProps";

export default (props: FormItemProps) => {
  const t = useTranslation();

  const options = useMemo(() => {
    if (!props.items) return [];
    const supplier = props.items
      .filter((item) => item.supplier)
      .map((item) => ({ value: item.supplier }));

    return arrayToDistinct(supplier, (obj) => obj.value);
  }, [props.items]);

  return (
    <Form.Item
      label={t("maintenance:items.create.form.supplier.label")}
      name="supplier"
      initialValue={props.editItem?.supplier}
    >
      <AutoComplete options={options} filterOption />
    </Form.Item>
  );
};
